// src/common/review.schema.ts
import { z } from "zod";
var seenVersionSchema = z.object({
  seenUpdatedAt: z.string().datetime()
});

export {
  seenVersionSchema
};
//# sourceMappingURL=chunk-L6ZPEPR3.js.map